import React, {Component} from "react";
import {connect} from 'react-redux'
import {Row} from 'antd';

//component
import ViewTable from '../../Table/ViewTable'
import {MESSAGE} from '../../../constants/dictionaries'
import DownloadFileModal from '../../../components/DownloadFile'
//helper
import columns from './columns'
import Api_dms from "../../../api/api.dms";

class Licenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setModal: false,
      selectdFile: []
    }
  }
  downFile = (data) => {
    new Api_dms().DownloadFile({
      token: this.props.user.access_token,
      data: {oid: data.idFile, filename: data.tenTaiLieu}
    })
  }
  downloadFile = (data) => {
    if (data.files !== undefined && data.files.length > 0) {
      if (data.files.length > 1) {
        this.setState({
          setModal: true,
          selectdFile: data.files
        })
      } else {
        this.downFile(data.files[0])
      }
    }
  }

  render() {
    const {dataSource = []} = this.props;
    const {setModal, selectdFile} = this.state
    let dataSourceIndex = dataSource.map((c, index) => ({...c, stt: index + 1}));
    
    return (
      <Row>
        <ViewTable
          locale={{emptyText: MESSAGE.CSCORE_THERE_IS_NO_DATA}}
          columns={columns({handleShowDetail: this.downloadFile})}
          dataSource={dataSourceIndex} pagination={false}
        />
        {setModal &&
            <DownloadFileModal
              isOpen={setModal}
              handleCancel={() => this.setState({setModal: false})}
              selectdFile={selectdFile}
            />}
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({user: state.oidc.user});
export default connect(mapStateToProps)(Licenses);